export default __webpack_public_path__ + "static/media/禁漫天堂.f77a47ca.jpg";